import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlacesAutocompleteComponent } from './places-autocomplete.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { AppAutoFocusDirectiveModule } from '../directives/app-auto-focus/app-auto-focus.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

@NgModule({
  declarations: [PlacesAutocompleteComponent],
  exports: [PlacesAutocompleteComponent],
  imports: [
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    CommonModule,
    AppAutoFocusDirectiveModule,
    GooglePlaceModule,
  ],
  providers: [],
})
export class PlacesAutocompleteModule {}
